@if (!_isEsiMode && !urlAddress.isDedicationDatePicker && !isMinimal) {
    <div class="print-hide">
        <ng-template #esiHost></ng-template>
    </div>
}
